var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgMagnifierMinus = function SvgMagnifierMinus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 12h6a1 1 0 110 2h-6a1 1 0 110-2z",
    fill: "#023F80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 4a9 9 0 105.618 16.032l4.675 4.675a1 1 0 001.414-1.414l-4.675-4.675A9 9 0 0013 4zm0 2a7 7 0 100 14 7 7 0 000-14z",
    fill: "#023F80"
  })));
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwIDEySDEySDE0SDE2QzE2LjU1MjMgMTIgMTcgMTIuNDQ3NyAxNyAxM0MxNyAxMy41NTIzIDE2LjU1MjMgMTQgMTYgMTRIMTRIMTJIMTBDOS40NDc3MiAxNCA5IDEzLjU1MjMgOSAxM0M5IDEyLjQ0NzcgOS40NDc3MiAxMiAxMCAxMloiIGZpbGw9IiMwMjNGODAiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMyA0QzguMDI5NDQgNCA0IDguMDI5NDQgNCAxM0M0IDE3Ljk3MDYgOC4wMjk0NCAyMiAxMyAyMkMxNS4xMjUgMjIgMTcuMDc4IDIxLjI2MzUgMTguNjE3NyAyMC4wMzE5TDIzLjI5MjkgMjQuNzA3MUMyMy42ODM0IDI1LjA5NzYgMjQuMzE2NiAyNS4wOTc2IDI0LjcwNzEgMjQuNzA3MUMyNS4wOTc2IDI0LjMxNjYgMjUuMDk3NiAyMy42ODM0IDI0LjcwNzEgMjMuMjkyOUwyMC4wMzE5IDE4LjYxNzdDMjEuMjYzNSAxNy4wNzggMjIgMTUuMTI1IDIyIDEzQzIyIDguMDI5NDQgMTcuOTcwNiA0IDEzIDRaTTEzIDZDOS4xMzQwMSA2IDYgOS4xMzQwMSA2IDEzQzYgMTYuODY2IDkuMTM0MDEgMjAgMTMgMjBDMTYuODY2IDIwIDIwIDE2Ljg2NiAyMCAxM0MyMCA5LjEzNDAxIDE2Ljg2NiA2IDEzIDZaIiBmaWxsPSIjMDIzRjgwIi8+Cjwvc3ZnPgo=";
export { SvgMagnifierMinus as ReactComponent };